module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, _vm._l((_vm.cardsData), function(card) {
    return _c('el-col', {
      key: card.id,
      attrs: {
        "sm": 24,
        "md": 6
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('lee-status-card', {
      attrs: {
        "icon": card.icon,
        "count": card.count,
        "type": card.type,
        "name": card.name
      }
    })], 1)])
  })), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 16
    }
  }, [_c('lee-progress', {
    attrs: {
      "title": "Skills",
      "progressData": _vm.progressData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8
    }
  }, [_c('lee-user-overview', {
    attrs: {
      "user": _vm.user,
      "profile": _vm.profileData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 16
    }
  }, [_c('lee-step', {
    attrs: {
      "title": "Steps For What To Do Today",
      "stepData": _vm.stepData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "lee-panel"
  }, [_c('div', {
    staticClass: "heading warning-text"
  }, [_vm._v("\n          Cost\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ve-pie', {
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.pieSettings,
      "height": "360px"
    }
  })], 1)]), _vm._v(" "), _c('lee-weather', {
    attrs: {
      "weatherData": _vm.weatherData
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04fdddbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 594
// module chunks = 1